import {appConfig} from "@/lib/appConfig";
import locations from "@/lib/locations.json";
import {v4} from 'uuid';

export function useMetrics() {
    const url = appConfig.domain + '/metrics'
    const eventTypes = {
        CHRONICLES: 'CHRONICLES',
        FIREWORK: 'FIREWORK',
        RUSSIA: 'RUSSIA',
        ATOM: 'ATOM',
        VDNH: "VDNH", //Прогулка ВДНХ
        VANYA: "VANYA", // Экскурсия с Ваней
    }

    const hitType = {
        HEADER_LINK: 'HEADER_LINK',
        BANNER_LINK: 'BANNER_LINK',
        RUN_GAME_BANNER: 'RUN_GAME_BANNER',
        RUN_GAME: 'RUN_GAME',
        END_GAME: 'END_GAME',
        SKIP_VIDEO: 'SKIP_VIDEO',
        SELECT_VIDEO: 'SELECT_VIDEO',
        QUIZ: 'QUIZ',
        SHARE: 'SHARE',
        REVIEW: 'REVIEW',
        BOOK_EVENT: 'BOOK_EVENT',
        UNSUBSCRIBE_EVENT: "UNSUBSCRIBE_EVENT",
        SELECT_EVENT: 'SELECT_EVENT', //Клик по банеру
        ENTER_EVENT: 'ENTER_EVENT', //Переход на мероприятия
        START_EVENT: 'START_EVENT', //Начало мероприятия
        EXIT_EVENT: "EXIT_EVENT",
        OPEN_MAP: 'OPEN_MAP', // взаимодействие с картой
        TELEPORT: 'TELEPORT', //Телепорт
        INTERACTION_SCOOTER: "INTERACTION_SCOOTER",  //взаимодействие с самокатом
        INTERACTION_KOSMOS: "INTERACTION_KOSMOS", // взаимодействие с объектом космоса
        START_RECORD: "START_RECORD", // запись экрана
        IS_DESKTOP: "IS_DESKTOP",
        IS_WEB: "IS_WEB",
        IS_MOBILE: "IS_MOBILE",
    }

    function getUuid() {
        return localStorage.getItem('uuid')
    }

    function setUuid() {
        localStorage.setItem('uuid', v4());
    }


    function getMetricsEventType(event) {
        if (!event) return eventTypes.VDNH;

        const {mapPath, eventPlace} = event;

        if (eventPlace?.trim() === locations.russian.place?.trim()) {
            return eventTypes.RUSSIA;
        }

        if (eventPlace?.trim() === locations.atom.place?.trim()) {
            return eventTypes.ATOM;
        }

        switch (mapPath?.toLowerCase()) {
            case locations.greenChronics.MapPath?.trim().toLowerCase():
                return eventTypes.CHRONICLES;
            case locations.aveleks.MapPath?.trim().toLowerCase():
                return eventTypes.VANYA;
            default:
                return eventTypes.VDNH;
        }
    }

    async function hit(event, type, meta = {}) {
        const  copyMeta = structuredClone?.(meta) ?? JSON.parse(JSON.stringify(meta));

        if (Reflect.has(copyMeta, 'eventSlots')) {
            Reflect.deleteProperty(copyMeta, 'eventSlots');
        }

        const uuid = getUuid();

        const data = {
            event,
            uuid,
            type,
            meta: copyMeta,
            timestamp: new Date().toISOString(),
        }

        // if (navigator.sendBeacon(url, JSON.stringify(data))) return;

        try {
            await fetch(url, {
                headers: {
                    'Content-Type': 'application/json',
                },
                keepalive: true,
                method: 'POST',
                body: JSON.stringify(data),
            });
        } catch (error) {
            console.error('Error send metric')
        }
    }

    return {
        eventTypes,
        hitType,
        getUuid,
        setUuid,
        hit,
        getMetricsEventType
    }
}